import React from 'react'

export default class PersonScreen extends React.Component{

	getIcons = array => {
		const {lang} = this.props
		let content = []
		for(let element in array){
			if(array[element]){
				const icon = array[element].field.icon_gelb.filename
				let assetpath = lang.concat('/properties/', icon)
				if(element > 1){
					assetpath = lang.concat('/screen_5/', icon)
				}
				content.push(
					<img className='icon' key={element} src={assetpath}/>
				)
			}
		}
		return content
	}

	setNameClass = className => {
		const {name, age} = this.props
		let newClass = className
		switch(className){
		case 'name':
			if(name) {
				if(name.length > 15){
					newClass = className + ' name--small name--visible'
				} else {
					newClass = className + ' name--visible'
				}
			} 
			break
		case 'age':
			if(age){
				newClass = className + ' age--visible'
			}
			break
		}
		return newClass
	}

	render(){
		const {
			data,
			gender,
			nationality,
			profession,
			religion,
			relationship,
			hobby,
			pet,
			selectedAge,
			name,
			lang,
			gender_id
		} = this.props

		const personscreenData = data.screen_4
		const residenceData = data.properties.residence
		const personData = personscreenData.persons

		const headline = personscreenData.text_1
		let personImage
		for(let person of personData){
			if(person.field.id === gender_id){
				personImage = person.field.image.filename
			}
		}
		const residenceText = personscreenData.text_2
		const ageText = personscreenData.text_3
		const personPath = lang.concat('/screen_4/', personImage)

		let residence = residenceText + ' ' + residenceData
		let age = ageText + ' '
		let iconArrayLeft = [gender, profession, hobby, pet]
		let iconArrayRight = [religion, nationality, relationship]

		return(
			<div className='personscreen'>
				<div className='iconcontainer'>
					{this.getIcons(iconArrayLeft)}
				</div>
				<div className='personcontainer'>
					<div className='headlinecontainer'>
						<div className='headline'>{headline}</div>
						<div className={this.setNameClass('name')}>{name}</div>
					</div>
					<img className='person' src={personPath}/>
					<div className='textcontainer'>
						<div className='residence'>{residence}</div>
						<div>{age}
							<span className={this.setNameClass('age')}>{selectedAge}</span>
						</div>
					</div>
				</div>
				<div className='iconcontainer'>
					{this.getIcons(iconArrayRight)}
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/splitScreen/personScreen.js